import React from 'react'
import { graphql, HeadProps, PageProps } from 'gatsby'

import { Container } from '../components/Container'
import { BaseLayout } from '../layouts/Base'
import { Section } from '../components/Section'
import { Hero } from '../components/Hero'
import { SEO } from '../components/SEO'
import { Services } from '../sections/Services'
import { Prose } from '../components/Prose'
import { ContactUs } from '../sections/ContactUs'
import { LinkButton } from '../components/LinkButton'
import { Jobs } from '../sections/Jobs'
import { Heading } from '../components/Heading'
import { HighlightedPost } from '../components/HighlightedPost'
import { Slideshow2 } from '../components/Slideshow2'
import { LearningKidsFinance } from '../sections/LearningKidsFinance'

const IndexPage = ({ data }: PageProps<Queries.IndexPageQueryQuery>) => {
  const { page, posts } = data
  const { content, pageHero } = page!
  const highlightedPost = posts?.nodes[0] || false
  const { slideshow } = pageHero!
  const { slideshowEnabled, slides, duration, transitionDuration } = slideshow!

  return (
    <BaseLayout>
      {slideshowEnabled && slides && (
        <Section>
          <div className="-mb-12">
            <Slideshow2
              slides={slides}
              duration={duration || 3}
              transitionDuration={transitionDuration || 500}
            />
          </div>
        </Section>
      )}

      <Section className="pt-0">
        <Container>
          {!slideshowEnabled && pageHero && pageHero.image && (
            <div className="mb-20 md:mb-0">
              <Hero
                heroTitle={pageHero.heroTitle}
                image={pageHero.image.gatsbyImage}
              />
            </div>
          )}

          {content && (
            <Prose
              className="prose-h2:font-light prose-h2:mt-2 prose-h2:mb-4 prose-img:rounded md:prose-2xl md:prose-p:mt-8 md:prose-figure:mt-8 md:prose-h2:text-8xl md:prose-h2:text-secondary md:prose-h2:font-light md:prose-h2:mb-4 md:prose-h2:mt-4"
              dangerouslySetInnerHTML={{ __html: content }}
            ></Prose>
          )}

          <Services
            sectionTitle="S čím vám pomůžeme"
            ctaElement={
              <LinkButton className="button--secondary" href="/sluzby">
                Více o službách
              </LinkButton>
            }
          />
        </Container>
      </Section>

      <LearningKidsFinance />

      {highlightedPost && (
        <Section>
          <Container>
            <div className="grid gap-8">
              <Heading as="h2">TOPTAX v&nbsp;médiích</Heading>

              <HighlightedPost post={highlightedPost} showBlogButton />
            </div>
          </Container>
        </Section>
      )}

      <Jobs limit={2} />

      <ContactUs />
    </BaseLayout>
  )
}

export default IndexPage

export const PageQuery = graphql`
  query IndexPageQuery {
    wp {
      allSettings {
        generalSettingsTitle
        generalSettingsDescription
      }
    }
    page: wpPage(isFrontPage: { eq: true }) {
      title
      content
      pageHero {
        heroTitle
        image {
          gatsbyImage(width: 1920)
        }
        slideshow {
          slideshowEnabled
          duration
          transitionDuration
          slides {
            slideTitle
            image {
              gatsbyImage(width: 1920)
            }
          }
        }
      }
    }
    posts: allWpPost(sort: { date: DESC }, limit: 1) {
      nodes {
        id
        title
        content
        excerpt
        slug
        featuredImage {
          node {
            gatsbyImage(width: 640, height: 320, placeholder: NONE)
          }
        }
      }
    }
  }
`

export const Head = ({ data }: HeadProps<Queries.IndexPageQueryQuery>) => {
  const { page, wp } = data!

  return (
    <SEO
      title={wp!.allSettings!.generalSettingsTitle!}
      description={wp!.allSettings!.generalSettingsDescription!}
    />
  )
}
